import { render, staticRenderFns } from "./OrderedByCard.vue?vue&type=template&id=887b1f8e&scoped=true&"
import script from "./OrderedByCard.vue?vue&type=script&lang=js&"
export * from "./OrderedByCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderedByCard.vue?vue&type=style&index=0&id=887b1f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887b1f8e",
  null
  
)

export default component.exports